import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { operations } from 'api/schema';
import { useLegalDocumentsQuery } from 'hooks/useLegalDocumentsQuery';

export type DeleteLegalDocumentVersionMutationData = NonNullable<
  operations['destroyLegalDocumentVersions']['requestBody']
>['content']['application/json'];

async function deleteLegalDocumentVersion(apiClient: ApiClient, id: number) {
  return apiClient.DELETE('/op/v2/legal-document-versions/{id}', { params: { path: { id } } });
}

export default function useDeleteLegalDocumentVersionMutation(id: number) {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<InferFetchData<typeof deleteLegalDocumentVersion>, ApiError, DeleteLegalDocumentVersionMutationData>({
    mutationKey: ['DeleteLegalDocumentVersion'],
    mutationFn: () => throwOnError(deleteLegalDocumentVersion(apiClient, id)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useLegalDocumentsQuery.getKey() });
    },
  });
}
